import React from 'react';

export default {

  pluralize: (count, text) => {
    const segments = Array.isArray(text) ? text : [text];
    return count == 1 ? `1 ${segments.join(' ')}` : `${count} ${segments.map(s => `${s}s`).join(' ')}`;
  },

  pluralize_without_count: (count, text) => {
    const segments = Array.isArray(text) ? text : [text];
    return count == 1 ? segments.join(' ') : segments.map(s => `${s}s`).join(' ');
  },

  nl2br: (text) => {
    return (text || "").split('\n').map((item, key) => {
      return <span key={key}>{item}<br/></span>
    });
  },

  simpleFormat: (text) => {
    return (text || "").replace(/\r/g, '').split('\n\n').map((text, key) =>
      <p key={key}>
        {text.split('\n').length > 1 ?
          text.split('\n').map((t, i) => {
            return t.length > 0 ? <span key={i}>{t}<br/></span> : null;
          })
          : text
        }
      </p>
    );
  },

  checkHttp: (url) => {
    return url.indexOf("http") == 0 ? url : `http://${url}`;
  },

  jsonFromLocalStorage: (key, defaultData = null) => {
    const localData = localStorage.getItem(key);
    return localData && localData.length > 0 ? JSON.parse(localData) : defaultData;
  },

  country: (fromId, countries) => {
    const country = countries.find(c => c.value == fromId) || {};
    return country.label;
  }

};
